// extracted by mini-css-extract-plugin
module.exports = {"breakpoint_xs":"30rem","breakpoint_sm":"48rem","breakpoint_md":"60rem","breakpoint_lg":"80rem","breakpoint_xl":"100rem"};